define([
    "./nlgNavigateModule",
    "./nlgNavigateDirective"
], function () {
});